// extracted by mini-css-extract-plugin
export default {"item":"IngredientItem_item__DucBw","itemName":"IngredientItem_itemName__3rrdK","orderPrice":"IngredientItem_orderPrice__AquMD","orderSum":"IngredientItem_orderSum__LJNUY"};